const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center gap-4 rounded-2xl border border-dashed border-gray-200 bg-white py-16 px-6 text-center">
    {Icon && (
      <div className="grid h-16 w-16 place-items-center rounded-2xl bg-brand-50 text-brand-300">
        <Icon className="h-9 w-9" strokeWidth={1.5} aria-hidden />
      </div>
    )}
    <div className="space-y-1">
      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      {description && <p className="mx-auto max-w-sm text-sm text-gray-500">{description}</p>}
    </div>
    {action}
  </div>
)

export default EmptyState
